var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M1.608 1a.608.608 0 1 0 0 1.217h1.083a.42.42 0 0 1 .4.288l2.006 6.02c.09.267.1.555.032.828l-.165.662c-.242.97.513 1.937 1.512 1.937h7.301a.608.608 0 0 0 0-1.217H6.476a.33.33 0 0 1-.332-.424l.125-.498a.39.39 0 0 1 .378-.295h6.522a.61.61 0 0 0 .577-.416l1.622-4.867a.61.61 0 0 0-.577-.801H4.988a.42.42 0 0 1-.4-.289l-.577-1.73A.61.61 0 0 0 3.434 1zm4.26 11.56a1.217 1.217 0 1 0 0 2.434 1.217 1.217 0 0 0 0-2.434m7.3 0a1.217 1.217 0 1 0 0 2.434 1.217 1.217 0 0 0 0-2.434"
})));
export default SvgCart;